import { render, staticRenderFns } from "./ConsignmentNotesRegistry.vue?vue&type=template&id=e304d538&scoped=true&"
import script from "./ConsignmentNotesRegistry.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNotesRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e304d538",
  null
  
)

export default component.exports